import React from "react";
import {
  Button,
  Paper,
  TextField,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";
import Buttons from "../../../../components/Uploader/uploadButtons";

const UploadImage = props => {
  const { uploadMethod, handleClose, handleImageUpload, handleChange, administrator, chatImage, classes, type } = props;
 
 console.log(props)
  return (
    <Paper className={classes.row} elevation={0}>
      <DialogTitle id="form-dialog-title">
        {uploadMethod === "web" ? "Upload Image from Web" : "Upload Image"}
      </DialogTitle>
      <DialogContent dividers>
        {uploadMethod === "web" ? (
          <TextField
            id="chat_image"
            className={classes.textfield}
            variant="outlined"
            label="Chat Image URL"
            onChange={event => handleChange(type, event.target.value)}
            value={chatImage}
            autoFocus
            margin="dense"
            fullWidth
            helperText="Example: http://www.example.com/images/image.png (JPG, PNG, BMP)"
          />
        ) : (
          <>
            <DialogContentText>
              We support images with following extensions - .jpg, .png, .bmp, .svg Filesize limit is 1MB
            </DialogContentText>
            <Buttons onChange={handleImageUpload} accepts={".jpg, .png, .bmp .svg"} disabled={!administrator} />
          </>
        )}
      </DialogContent>
      <DialogActions>
      <Button color="primary" onClick={handleClose}>
          cancel
        </Button>
        <Button color="primary" onClick={handleClose}>
          Save
        </Button>
      </DialogActions>
    </Paper>
  );
};

export default UploadImage;
